import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { top: "", "max-width": "400" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on: onTooltip }) {
            return [
              _c(
                "div",
                _vm._g({}, { ...onTooltip }),
                [
                  _c(VSelect, {
                    attrs: {
                      items: _vm.value.lista,
                      label: "Ordenar por:",
                      "item-text": "descricao",
                      "prepend-icon": _vm.value.decrescente ? "south" : "north",
                      dense: _vm.dense,
                      "return-object": "",
                    },
                    on: { input: _vm.change, "click:prepend": _vm.change },
                    model: {
                      value: _vm.value.selecionado,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "selecionado", $$v)
                      },
                      expression: "value.selecionado",
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Selecione para ordenar os dados")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }